import { FC } from "react";

interface ArrowOutwardIconProps {}

const ArrowOutward: FC<ArrowOutwardIconProps> = (props: ArrowOutwardIconProps) => {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.00272 11.0276L3.3501 10.375L9.50035 4.21872H3.90899V3.28125H11.0965V10.4687H10.159V4.87736L4.00272 11.0276Z"
        fill="black"
      />
    </svg>
  );
};

export default ArrowOutward;
